import { useGlobalModalContext } from 'context/GlobalModal';
import { DashboardRoutePath } from 'modules/dashboard';

import { Button, Input, Modal, Splash } from '../../../shared/Components';
import DatePickerInput from '../../../shared/Components/DatePickerInput';
import { FlexContainer, Text } from '../../../shared/Typhography';

import useAddEditDailyPuzzle from './hooks/useAddEditDailyPuzzle';
import { InputFieldsBox, PuzzleDetailsBox, PuzzleDetailsImage, PuzzleDetailsName } from './styles';

type CreateDailyPuzzleProps = {
  editDailyPuzzleId?: string;
  dotDays?: Date[];
  onSaveCallback?: () => void;
};

const CreateDailyPuzzle = (props: CreateDailyPuzzleProps) => {
  const { dotDays, editDailyPuzzleId, onSaveCallback } = props;

  const { isLoading, submit, control, date, setValue, puzzleData, puzzleId } =
    useAddEditDailyPuzzle({
      editDailyPuzzleId,
      onSaveCallback,
    });

  const { hideModal } = useGlobalModalContext();

  return (
    <Modal onRequestClose={() => hideModal()} height={600}>
      <div style={{ width: '100%' }}>
        <Text
          style={{ width: '100%', marginBottom: 80 }}
          weight="bold"
          size={1.5}
          textAlign="center"
        >
          {editDailyPuzzleId ? 'Edit' : 'Create'} Daily Puzzle
        </Text>
        <InputFieldsBox>
          <Input
            required
            type="text"
            name="puzzleId"
            control={control}
            placeholder="Puzzle ID*"
            width="100%"
            margin="0 0 10px 0"
          />
          <DatePickerInput
            selected={date}
            onChange={(value: Date) => {
              value.setUTCFullYear(value.getFullYear());
              value.setUTCMonth(value.getMonth());
              value.setUTCDate(value.getDate());
              value.setUTCHours(0, 0, 0, 0);
              setValue('date', value);
            }}
            disabled={editDailyPuzzleId ? true : false}
            inline={true}
            selectsRange={false}
            label="Date*"
            minDate={new Date()}
            dotDays={dotDays ?? []}
          />
        </InputFieldsBox>
        {puzzleData && puzzleId && (
          <FlexContainer justifyContent="center">
            <PuzzleDetailsBox>
              <PuzzleDetailsName>{puzzleData?.name}</PuzzleDetailsName>
              <FlexContainer
                justifyContent="center"
                onClick={() =>
                  window.open(`/${DashboardRoutePath.VIEW_PUZZLE}/${puzzleData?.uuid}`, '_blank')
                }
              >
                <PuzzleDetailsImage src={puzzleData?.iconURL} />
              </FlexContainer>
            </PuzzleDetailsBox>
          </FlexContainer>
        )}
        {!puzzleData && puzzleId && !isLoading && (
          <Text style={{ textAlign: 'center', marginTop: 20 }}>
            Puzzle with given ID does not exist.
          </Text>
        )}
      </div>
      <FlexContainer width="100%" justifyContent="space-evenly">
        {isLoading && <Splash position="relative" />}
        {!isLoading && (
          <>
            <Button onClick={() => hideModal()}>
              <Text color="white" padding="5px" size={1.2} cursor="pointer" weight="bold">
                Cancel
              </Text>
            </Button>
            <Button onClick={() => submit()}>
              <Text color="white" padding="5px" size={1.2} cursor="pointer" weight="bold">
                {editDailyPuzzleId ? 'Save' : 'Create'}
              </Text>
            </Button>
          </>
        )}
      </FlexContainer>
    </Modal>
  );
};

export default CreateDailyPuzzle;
